import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CreateSecretRequest, QueryKey } from 'api/model';
import { toast } from 'react-toastify';
import { getProjectSecrets, getGlobalSecrets, createSecret } from './requests';
import { errorHandler } from 'api/axios_instance';

const queryKey = QueryKey.Secrets;

const useSecrets = (projectId: string | null = null, includeGlobal = false, enabled = true) => {
  const queryClient = useQueryClient();

  const queryFn = () => (projectId === null ? getGlobalSecrets() : getProjectSecrets(projectId, includeGlobal));
  const {
    data: secrets,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: [queryKey, { projectId, includeGlobal }],
    queryFn: queryFn,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled,
  });

  const create = useMutation({
    mutationFn: (secret: CreateSecretRequest) => createSecret(secret),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [queryKey] });
      toast.success('Secret successfully created');
    },
    onError: errorHandler('Creating secret failed'),
  });

  return { secrets, isLoading, create, isFetching };
};

export { queryKey };
export default useSecrets;
